import { createSlice } from '@reduxjs/toolkit';

import { logOut } from 'common/auth/authService';

import { AuthActions } from './actions';
import { InitialState } from './models';

const initialState: InitialState = {
  tokens: null,
  registrationStatus: null,
  kycStatus: null,
  surveyFilled: false,
  isLoading: false,
  user: null,
};

const authSlice = createSlice({
  name: 'authSlice',
  initialState,
  reducers: {
    clearStore: () => {
      logOut();
    },
  },
  extraReducers(builder) {
    builder.addCase(AuthActions.signIn.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(AuthActions.signIn.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(AuthActions.signIn.fulfilled, (state, action) => {
      state.isLoading = false;
      state.tokens = action.payload.data.tokens;
      state.registrationStatus = action.payload.data.registrationStatus;
      state.kycStatus = action.payload.data.kycStatus;
      state.surveyFilled = action.payload.data.surveyFilled;
    });
    builder.addCase(
      AuthActions.getInvestorAccount.fulfilled,
      (state, action) => {
        state.user = action.payload;
      }
    );
    builder.addCase(AuthActions.logout.fulfilled, (state, action) => {
      state.user = action.payload;
    });
  },
});

export const AuthSliceActions = authSlice.actions;
export default authSlice.reducer;
